import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const programs = [
    {
        title: "BBA Digital Marketing",
        link: "/bba-digital-marketing",
    },
    {
        title: "BBA Fintech",
        link: "/bba-fintech",
    },
    {
        title: "BCA Cyber Security",
        link: "/bca-cybersecurity",
    },
    {
        title: "BCA Artificial Intelligence & Machine Learning",
        link: "/bca-artificial-intelligence-and-machine-learning",
    },
    {
        title: "B.Sc. Hospitality & Hotel Administration",
        link: "/bsc-hospitality-and-hotel-management",
    },
];

const Sec3 = () => {
    return (
        <section className="py-5 bg-light">
            <Container>
                <div className="row justify-content-center g-4">
                    {programs.map((program, index) => (
                        <div className="col-md-2 col-sm-6 text-center" key={index}>
                            <div className="p-4 bg-white border rounded shadow-sm h-100">
                                <h5 className="mb-4">{program.title}</h5>
                                <Link to={program.link} className="btn btn-warning">
                                    View Program
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </Container>
        </section>
    );
};

export default Sec3;
